// extracted by mini-css-extract-plugin
module.exports = {"AddGamePage":"AddGamePage","AddGamePage__PatchNotes":"AddGamePage__PatchNotes"};